export default __webpack_public_path__ + "static/media/farmlands_environment_c.e5853f3b.mp4";